const chunkMapping = {
	"3": [
		1375
	],
	"38": [
		6565
	],
	"72": [
		7072
	],
	"166": [
		7573
	],
	"234": [
		947
	],
	"244": [
		681
	],
	"365": [
		4355
	],
	"421": [
		5735
	],
	"464": [
		3637
	],
	"529": [
		2843
	],
	"659": [
		865
	],
	"703": [
		8773
	],
	"741": [
		5895
	],
	"791": [
		6113
	],
	"891": [
		5457
	],
	"990": [
		2117
	],
	"993": [
		6045
	]
};
const idToExternalAndNameMapping = {
	"681": [
		"default",
		"./HeaderApp",
		2640
	],
	"865": [
		"default",
		"./EcommerceApp",
		682
	],
	"947": [
		"default",
		"./AuthApp",
		2096
	],
	"1375": [
		"default",
		"./BookingBuilderApp",
		2356
	],
	"2117": [
		"default",
		"./EmailBuilderApp",
		2504
	],
	"2843": [
		"default",
		"./CustomerAuthenticationApp",
		1428
	],
	"3637": [
		"default",
		"./DynamicFormsAdminApp",
		8100
	],
	"4355": [
		"default",
		"./DynamicFormsApp",
		2148
	],
	"5457": [
		"default",
		"./SidebarApp",
		9558
	],
	"5735": [
		"default",
		"./ServicesApp",
		732
	],
	"5895": [
		"default",
		"./WebsiteBuilderApp",
		8540
	],
	"6045": [
		"default",
		"./POSApp",
		9226
	],
	"6113": [
		"default",
		"./MarketingApp",
		4786
	],
	"6565": [
		"default",
		"./OffersApp",
		6864
	],
	"7072": [
		"default",
		"./IdleSessionApp",
		4052
	],
	"7573": [
		"default",
		"./POSBackOfficeApp",
		736
	],
	"8773": [
		"default",
		"./ProductManagementApp",
		9694
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}